'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { AuthQueryOptions } from '@/api';
import { Image } from '@/components/client';
import { useAuthStore } from '@/stores/AuthStore';
import { IMAGE_URL_PREFIX } from '../../constants';
import { ChallengeListItem } from './ChallengeListItem';
import { CHALLENGE_LIST } from './constants';
export const ChallengeSection = () => {
  const $ = _c(17);
  const isLogin = useAuthStore(_temp);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = AuthQueryOptions["get:/wello/v2/auth/home-donation/event/local-tour"]();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== isLogin) {
    t1 = {
      ...t0,
      enabled: isLogin,
      select: _temp2
    };
    $[1] = isLogin;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: localTourData
  } = useQuery(t1);
  const donationCount = localTourData?.donationCount ?? 0;
  let t2;
  if ($[3] !== donationCount) {
    t2 = CHALLENGE_LIST.findLastIndex(item => donationCount >= item.challengeCount);
    $[3] = donationCount;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const highestCompletedIndex = t2;
  let t3;
  if ($[5] !== donationCount || $[6] !== highestCompletedIndex) {
    t3 = CHALLENGE_LIST.map((item_0, index) => ({
      ...item_0,
      isCompleted: index === highestCompletedIndex && donationCount >= item_0.challengeCount
    }));
    $[5] = donationCount;
    $[6] = highestCompletedIndex;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const challengeItemsWithStatus = t3;
  let t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <header className="flex flex-col gap-8 pb-24 text-center"><h2 className="font-600 text-Gray-white typo-h6">돌아온 지역 기부 챌린지</h2><h3 className="font-800 text-Gray-white typo-h4">경품도 더 푸짐해졌어요!</h3></header>;
    t5 = <Image src={`${IMAGE_URL_PREFIX}/stamp-2-challenge-santa.png`} alt={"\uB9D0\uD48D\uC120\uC774 \uC788\uB294 \uC0B0\uD0C0 \uC774\uBBF8\uC9C0"} width={288} height={302.4} className="h-252 w-240" />;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[10] !== challengeItemsWithStatus) {
    t6 = challengeItemsWithStatus.map(_temp3);
    $[10] = challengeItemsWithStatus;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <ul className="flex w-full flex-col gap-12 pb-16">{t6}</ul>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ul className="flex flex-col items-center font-600 text-Gray-550 typo-body4"><li>*당첨자 발표*</li><li>1월 중 선별하여 개별 연락 및 공지사항을 통해 안내 예정</li></ul>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7) {
    t9 = <section className="bg-Gray-black px-24 py-64 flex-center"><div className="flex w-full max-w-[23.4375rem] flex-col items-center">{t4}{t5}{t7}{t8}</div></section>;
    $[15] = t7;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};
function _temp(state) {
  return state.isLogin;
}
function _temp2(t0) {
  const {
    context
  } = t0;
  return context;
}
function _temp3(t0) {
  const {
    benefit,
    image,
    label,
    isCompleted
  } = t0;
  return <ChallengeListItem key={label} label={label} benefit={benefit} image={image} isCompleted={isCompleted} />;
}